// extracted by mini-css-extract-plugin
export default {"hideOverflow":"styles_hideOverflow__zOsI4"};